import setCurrentPage from "src/Utils/setCurrentPage";
import setPreviousPage from "src/Utils/setPreviousPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "computerWithPolice",
    iconColor: "white",
    text: "AI assisted root cause \nanalysis and self-healing",
    listItemCustomStyle: { width: "254px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "computerWithPopUpOver",
    iconColor: "white",
    text: "AI assisted ITSM process \nfor Data & AI services",
    listItemCustomStyle: { width: "254px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "screenWithDollarSignAndGear",
    iconColor: "white",
    text: "Usage analytics and diagnostic to reduce licensing costs",
    listItemCustomStyle: { width: "254px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "brain",
    iconColor: "white",
    text: "Gen AI recommendation \nfor infrastructure sizing \nand code optimization",
    listItemCustomStyle: { width: "254px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_BENEFITS_DNA1_2 = {
  title: "50% REDUCTION IN PLATFORM \nOPERATIONS and CONSUMPTION COST",
  titleNumber: "2.",
  text: "Reducing cost of people, service management, infrastructure and product/cloud licensing \nthrough AI driven Cost Management Module.",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  next: {
    label: "Challenges Solved",
    onClick: () => setCurrentPage(104),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(102),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "DNA1/DNA1_intro_03.jpg",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  demoButtons: [
    {
      label: "DATA OPERATIONS WORKBENCH DEMO",
      onClick: () => {
        setPreviousPage(103);
        setCurrentPage(105);
      },
      endIcon: "play",
    },
  ],
};
